import SelectNewkng from './src/main';

/* istanbul ignore next */
SelectNewkng.install = function(Vue) {
  Vue.component(SelectNewkng.name, SelectNewkng);
};

export default SelectNewkng;
